import React, { useEffect, useState } from "react";
import { InputGroup, Form, Row, Col, Button, Container } from "react-bootstrap";
import searchService from "../../Services/searchService";
import Gallery from "../../Components/Gallery/Gallery";
import { useDispatch, useSelector } from "react-redux";
import assetService from "../../Services/assetService";
import {
  clearFilters,
  clearResults,
  setResults,
  setFulltext,
  addResults,
} from "../../Reducers/galleryReducer";
import SelectButton from "../../Components/Gallery/SelectButton/SelectButton";
import { useTranslation } from "react-i18next";
import "./MediaGallery.css";

const MediaGallery = () => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [next, setNext] = useState();

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const filters = useSelector((state) => state.gallery.filters);
  const results = useSelector((state) => state.gallery.results);
  const channelGuid = useSelector((state) => state.channel.channelGuid);

  useEffect(() => {
    dispatch(clearFilters());
    dispatch(clearResults());

    return () => {
      dispatch(clearResults());
      dispatch(clearFilters());
    };
  }, []);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        if (channelGuid) {
          const filterFields = await searchService.getFilterFields(channelGuid);

          setOptions([
            filterFields["ship"],
            filterFields["destination"],
            filterFields["onboard"],
          ]);
        }
      } catch (error) {
        console.error("Errore nel recupero delle opzioni:", error);
      }
    };

    fetchOptions();
  }, [channelGuid]);

  useEffect(() => {
    const fetchAssets = async () => {
      let body = {
        filters,
        "limit": 12,
      };
      setIsLoading(true);

      if (channelGuid) {
        try {
          let data;
          data = await assetService.getAssets(channelGuid, body);
          setNext(data?.next);
          dispatch(setResults(data.items));

          setIsLoading(false);
        } catch (error) {
          console.error("Errore nel recupero dei file multimediali:", error);
          setIsLoading(false);
        }
      }
    };
    fetchAssets();
  }, [filters, channelGuid]);

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(setFulltext(searchTerm));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch(e);
    }
  };

  const onClickMore = async () => {
    try {
      let body = {
        filters,
        "limit": 12,
        next,
      };

      if (channelGuid) {
        const moreData = await assetService.getAssets(channelGuid, body);
        setNext(moreData.next);
        dispatch(addResults(moreData.items));
      }
    } catch (error) {
      console.error("Errore nel recupero file multimediali:", error);
    }
  };

  return (
    <div className="container-fluid main-gallery">
      <Container className="form-container w-100 d-grid align-items-center">
        <Form className="container form-section">
          <Row className="search-row">
            <Col xs="12" md="9" className="h-100 searchbar">
              <Form.Label htmlFor="inlineFormInputGroup" visuallyHidden>
                Search
              </Form.Label>
              <InputGroup className="h-100">
                <InputGroup.Text>
                  <i className="bi bi-search"></i>
                </InputGroup.Text>
                <Form.Control
                  id="inlineFormInputGroup"
                  placeholder={t("search")}
                  value={searchTerm}
                  aria-label="Search"
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={handleKeyPress}
                />
              </InputGroup>
            </Col>
            <Col xs="12" md="3" className="h-100">
              <Button
                type="submit"
                className="h-100 w-100"
                onClick={(e) => handleSearch(e)}
              >
                {t("search")}
              </Button>
            </Col>
          </Row>
          <Row className="select-row">
            {options?.map((option, index) => {
              return (
                <SelectButton
                  key={index}
                  options={option}
                  placeholder={
                    index === 0
                      ? "Ship"
                      : index === 1
                      ? "Macro Area"
                      : "On Board"
                  }
                  setLoading={setIsLoading}
                />
              );
            })}
            <SelectButton
              placeholder={"Image & Video"}
              isClearable={false}
              setLoading={setIsLoading}
            />
          </Row>
        </Form>
      </Container>
      <Gallery
        mediaItems={results}
        isLoading={isLoading}
        getMoreAssets={onClickMore}
        next={next}
      />
    </div>
  );
};

export default MediaGallery;
